import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@paypalcorp/pp-react-checkbox';

class CheckboxField extends Component {
  static propTypes = {
    input: PropTypes.object,
    label: PropTypes.string,
    meta: PropTypes.object,
    id: PropTypes.string,
    disabled: PropTypes.bool,
  };

  render() {
    const { input, label, id } = this.props;

    const isDisabled = !!this.props.disabled;

    return (
      <Checkbox
        label={label}
        id={id}
        name={id}
        disabled={isDisabled}
        {...input}
      />
    );
  }
}
export default CheckboxField;
